export default __webpack_public_path__ + "img/rate.f16d4748.png";